import {
  FormSectionSchema,
  IncidentFormTypeSchema,
  WorkflowVersionSchema,
  type AnyWorkflow,
} from "../../types/index.js";
import { tk } from "../../types/Translation.js";
import { workflow_BTP_1_0 } from "../workflow_BTP_1_0/workflow.js";
import { btpAnonymiser } from "./anonymiser.js";
import { formSpecification as finishFormFormSpecification } from "./finishForm.js";
import { formSpecification as preEndIncidentFormSpecification } from "./preEndIncident.js";

export const workflow_BTP_1_1 = {
  ...workflow_BTP_1_0,
  anonymiser: btpAnonymiser,
  workflowVersion: WorkflowVersionSchema.enum.BTP_1_1,
  [IncidentFormTypeSchema.enum.preEndIncident]: {
    formDefinition: {
      sections: [
        {
          id: FormSectionSchema.enum.preEndIncident,
          name: tk("incidentFormSections.endForm"),
          autoSave: false,
          buildFormSpecification: preEndIncidentFormSpecification,
        },
      ],
    },
  },
  [IncidentFormTypeSchema.enum.finishForm]: {
    formDefinition: {
      sections: [
        {
          id: FormSectionSchema.enum.finishForm,
          name: tk("finishForm.finishFormTitle"),
          autoSave: false,
          buildFormSpecification: finishFormFormSpecification,
        },
      ],
    },
  },
} satisfies AnyWorkflow;
